import { render } from "./server-crash.vue?vue&type=template&id=22c08bda&scoped=true"
import script from "./server-crash.vue?vue&type=script&lang=js"
export * from "./server-crash.vue?vue&type=script&lang=js"

import "./server-crash.vue?vue&type=style&index=0&id=22c08bda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c08bda"]])

export default __exports__